import { Box, Card, Typography } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useState } from 'react';
import SVButton from '../SVButton';

type SVListStatsProps = {
  stats: Record<string, number | string>;
};

const SVListStats = ({ stats }: SVListStatsProps) => {
  const [showStats, setShowStats] = useState(false);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <SVButton
        onClick={() => setShowStats(!showStats)}
        startIcon={showStats ? <VisibilityOff /> : <Visibility />}
        sx={{
          display: { xs: 'inline-flex', sm: 'none' },
          mb: 1,
          alignSelf: 'flex-end',
          width: 'auto',
        }}>
        {showStats ? 'Hide Stats' : 'Show Stats'}
      </SVButton>
      <Box
        sx={{
          display: { xs: showStats ? 'flex' : 'none', sm: 'flex' },
          gap: 3,
          alignItems: 'center',
          flexWrap: 'wrap',
        }}>
        {Object.entries(stats).map(([title, value]) => (
          <Card
            key={title}
            sx={{
              display: 'flex',
              flexDirection: { xs: 'row', sm: 'column' },
              alignItems: { xs: 'center', sm: 'stretch' },
              justifyContent: { xs: 'space-between', sm: 'space-between' },
              width: { xs: '100%', sm: 200 },
              padding: '16px 24px',
              height: { xs: 'auto', sm: 120 },
              textAlign: { xs: 'left', sm: 'center' },
              position: 'relative',
              flexGrow: { xs: 0, sm: 1 },
            }}>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                flex: { xs: 1, sm: 'none' },
                textAlign: { xs: 'left', sm: 'center' },
                position: { sm: 'absolute' },
                top: { sm: '16px' },
                left: { sm: '24px' },
                right: { sm: '24px' },
              }}>
              {title}
            </Typography>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                textAlign: { xs: 'right', sm: 'center' },
                position: { sm: 'absolute' },
                bottom: { sm: '16px' },
                left: { sm: '24px' },
                right: { sm: '24px' },
              }}>
              {value}
            </Typography>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default SVListStats;
